<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/corpo-docente']"
              >Corpo Docente</a
            >
          </div>
          <h1 class="title text-white">Conheça o Corpo Docente</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      O corpo docente da Faculdade Facint é formado por mestres e doutores com
      ampla experiência acadêmica e atuação profissional nas suas respectivas
      áreas. Nossos professores aliam excelência teórica à prática do mercado,
      proporcionando uma formação atualizada, crítica e conectada às reais
      demandas da sociedade. Com forte compromisso ético e educacional, os
      docentes da Facint acompanham de perto o percurso dos estudantes,
      contribuindo para uma trajetória acadêmica sólida, humanizada e voltada à
      transformação social.
    </p>
  </div>
</div>
